// import React, { useState } from "react";
// import { API } from "../backend";
// import {
//   Box,
//   Button,
//   Card,
//   Container,
//   Grid,
//   MenuItem,
//   TextField,
//   Typography,
// } from "@mui/material";
// import { useFlutterwave } from "flutterwave-react-v3";
// import Footer from "../../Component/Footer";
// import axios from "axios";
// import { Link } from "react-router-dom";
// import { v4 as uuidv4 } from "uuid";
// import Logo from "../../images/logo.png";
// import ProceedModal from "../../Component/ProceedModal"; // will need to be changed to account for school ID i think
// import { styled } from "@mui/system";
// import Swal from "sweetalert2";

// const CustomTextField = styled(TextField)({
//   // "& .MuiInputBase-input.Mui-disabled": {
//   //     color: "red !important",
//   //     "-webkit-text-fill-color": "red !important",
//   //     borderColor: "red !important"
//   //   },
//   //   "& .Mui-disabled .MuiOutlinedInput-notchedOutline": {
//   //     borderColor: "red !important"
//   //   }
//   "& .MuiInputBase-input.Mui-disabled": {
//     color: "rgba(0,0,0,0.6) !important",
//     "-webkit-text-fill-color": "rgba(0,0,0,0.6) !important",
//     borderColor: "rgba(0,0,0,0.6) !important",
//   },
//   //   "& .Mui-disabled .MuiOutlinedInput-notchedOutline": {
//   //     borderColor: "rgba(0,0,0,0.38) !important"
//   //   }
// });

// const OtherServices = () => {
//   const [name, setName] = useState("");
//   const [serviceType, setServiceType] = useState("");
//   const [price, setPrice] = useState(null);
//   const [lasra, setLasra] = useState("");
//   const [payerId, setPayerId] = useState("");

//   const config = {
//     public_key: process.env.REACT_APP_PUBLIC_KEY,
//     tx_ref: Date.now(),
//     amount: price,
//     currency: "NGN",
//     payment_options: "card,mobilemoney,ussd",
//     customer: {
//       email: "balogunademola80@mailing.org",
//       phonenumber: "081728637267",
//     },
//     customizations: {
//       title: "Lagos Pay",
//       description: "PAYMENT FOR EXAMINATION (CBS)",
//       logo: "https://pbs.twimg.com/media/EtEwgbvXMAQfCXT.jpg",
//     },
//   };

//   const handleFlutterPayment = useFlutterwave(config);

//   const paymentServices = async () => {
//     const obj = {
//       PaymentType: serviceType,
//       Name: name,
//       TotalPrice: price,
//       PayerID: payerId,
//       LassraNumber: lasra,
//     };

//     console.log(obj);

//     // handlePayment()
//     try {
//       const resp = await axios.post(`${API}payall/`, obj);
//       console.log(resp);
//       if (resp.status === 201) {
//         Swal.fire({
//           title: "Successful",
//           text: `You have successfully paid for your ${resp.data.PaymentType}`,
//           icon: "success",
//           confirmButtonText: "Ok",
//         });

//         setServiceType("");
//         setName("");
//         setPrice("");
//         setPayerId("");
//         setLasra("");
//       }
//     } catch (err) {
//       console.error(err);
//     }
//   };

//   const handlePayment = async () => {
//     handleFlutterPayment({
//       callback: (response) => {
//         if (response.status === "successful") {
//           paymentServices();
//         }
//       },
//       onClose: () => {},
//     });
//   };

//   const handleClick = async (e) => {
//     handlePayment();
//   };

//   return (
//     <div className="main-dues-container">
//       <Box component="div" className="dues">
//         <Container>
//           <Card className="dues-card" elevation={5}>
//             <Box
//               component="form"
//               noValidate
//               autoComplete="off"
//               className="dues-form-left"
//             >
//               <Typography
//                 variant="h5"
//                 align="center"
//                 sx={{ paddingTop: "3rem", fontWeight: "bold" }}
//               >
//                 Service Type
//               </Typography>

//               <Container sx={{ mt: 5 }}>
//                 <div>
//                   <div>
//                     <CustomTextField
//                       id="standard-basic"
//                       variant="standard"
//                       label="Select Service Type"
//                       fullWidth
//                       select
//                       value={serviceType}
//                       onChange={(e) => {
//                         setServiceType(e.target.value);
//                       }}
//                     >
//                       <MenuItem value={"TEDAC"}>TEDAC</MenuItem>
//                       <MenuItem value={"Name Coorection"}>
//                         Correction of name
//                       </MenuItem>
//                       <MenuItem value={"Change Of Status"}>
//                         Change of Status
//                       </MenuItem>
//                       <MenuItem value={"Collection Of Certificates"}>
//                         Collection of Certificate
//                       </MenuItem>
//                       <MenuItem value={"Reactivation Of School Codes"}>
//                         Re-activation of Shcool Code
//                       </MenuItem>
//                       <MenuItem value={"B.E.C.E Result"}>BECE Re-Sit</MenuItem>
//                     </CustomTextField>
//                   </div>

//                   <div>
//                     <CustomTextField
//                       id="standard-basic"
//                       label="Name"
//                       variant="standard"
//                       fullWidth
//                       className="dues-form-field"
//                       value={name}
//                       onChange={(e) => {
//                         setName(e.target.value);
//                       }}
//                     />
//                   </div>

//                   <div>
//                     <CustomTextField
//                       id="standard-basic"
//                       label="Price"
//                       variant="standard"
//                       fullWidth
//                       className="dues-form-field"
//                       type={"number"}
//                       value={price}
//                       onChange={(e) => {
//                         setPrice(e.target.value);
//                       }}
//                     />
//                   </div>

//                   <div>
//                     <CustomTextField
//                       id="standard-basic"
//                       label="Payer ID"
//                       variant="standard"
//                       fullWidth
//                       className="dues-form-field"
//                       // type={'number'}
//                       value={payerId}
//                       onChange={(e) => {
//                         setPayerId(e.target.value);
//                       }}
//                     />
//                   </div>

//                   <div>
//                     <CustomTextField
//                       id="standard-basic"
//                       label="LASRA No"
//                       variant="standard"
//                       fullWidth
//                       className="dues-form-field"
//                       value={lasra}
//                       onChange={(e) => {
//                         setLasra(e.target.value);
//                       }}
//                     />
//                   </div>

//                   <div style={{ marginTop: "3rem" }}>
//                     <Button
//                       color="success"
//                       variant="contained"
//                       sx={{
//                         textTransform: "inherit",
//                         fontWeight: "bold",
//                         mr: "5px",
//                       }}
//                       onClick={handleClick}
//                     >
//                       Place Request
//                     </Button>

//                     <Link
//                       component="button"
//                       to="/"
//                       sx={{ textDecoration: "none" }}
//                     >
//                       <Button
//                         variant="text"
//                         sx={{
//                           textTransform: "inherit",
//                           fontWeight: "bold",
//                           ml: "5px",
//                           color: "black",
//                         }}
//                       >
//                         Go back
//                       </Button>
//                     </Link>
//                   </div>
//                 </div>
//               </Container>
//             </Box>
//             <Box compnent="div" className="dues-form-right">
//               <Typography
//                 variant="h4"
//                 align="center"
//                 sx={{
//                   color: "#ffffff",
//                   paddingTop: "3rem",
//                   fontWeight: "bold",
//                 }}
//               >
//                 Lagos State Exam Board
//               </Typography>
//               <div
//                 style={{
//                   display: "flex",
//                   justifyContent: "center",
//                   marginTop: "5rem",
//                 }}
//               >
//                 <img src={Logo} alt="logo" />
//               </div>
//               <Typography
//                 variant="h4"
//                 align="center"
//                 sx={{ color: "white", paddingTop: "2rem", fontWeight: "bold" }}
//               >
//                 Other Services
//               </Typography>
//               <Typography
//                 variant="body2"
//                 align="center"
//                 sx={{ color: "white", padding: ".3rem 1rem" }}
//               >
//                 Fill the form to request for the Official Central Billing System
//                 Invoice ID
//               </Typography>
//             </Box>
//           </Card>
//         </Container>
//         {/* <ProceedModal piepie={pinNum} open={open} handleClose={handleClose} /> */}
//       </Box>
//       <Footer />
//     </div>
//   );
// };

// export default OtherServices;

import React, { useState, useEffect } from "react";

import Layout from "../../reusables/layout/layout";
import RequsitionService from "../../Component/requisitionforms/requisitionService";

const Tedac = () => {
  return (
    <div>
      <Layout>
        <RequsitionService examType={"TEDAC"} examName={"TEDAC"} />
      </Layout>
    </div>
  );
};

export default Tedac;
